<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="gimItemTypes"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-gim-item-type") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'gimItemTypes'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-gim-item-type
      :modelDialog="gimItemTypeDialog"
      @close="gimItemTypeDialog = false"
    ></add-edit-gim-item-type>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditGimItemType from "./admin/AddEditGimItemType.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "SapgAdmin",
  components: { AddEditGimItemType, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      gimItemTypeDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      gimItemTypes: (state) => state.gimItemTypes.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.gimItemTypes.editedId
    }),
    pageCount() {
      return Math.ceil(this.gimItemTypes.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "gimItemTypes");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "gimItemTypes");
    },
    openDialog() {
      this.$store.commit("gimItemTypes/setEditedId", -1);
      this.$store.commit("gimItemTypes/setEditedItem", Object.assign({}, {}));
      this.gimItemTypeDialog = true;
    },
    editItem(item) {
      this.$store.commit("gimItemTypes/setEditedId", item.id);
      this.$store.commit("gimItemTypes/setEditedItem", Object.assign({}, item));
      this.gimItemTypeDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.gim-item-type"))) {
        this.$store
          .dispatch("gimItemTypes/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.gim-item-type-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "gimItemTypes");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.gim-item-type-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
